import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/button';
import CustomInput from '../../components/customInput/CustomInput';
import { isEmailValid } from '../../utils/commonUtil';
import { resetPassword } from '../../redux/passwordResetSlice';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isEmailValidated, setIsEmailValidated] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error, status } = useSelector((state) => state.passwordReset);

  useEffect(() => {
    if (status === 'succeeded') {
      setIsEmailValidated(true);
    }
  }, [status]);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrorMessage('');
  };

  const handleSubmit = async () => {
    if (!email.trim()) {
      setErrorMessage('Please enter correct email format!');
      return;
    }
    if (!isEmailValid(email)) {
      setErrorMessage('Please enter correct email format!');
    } else {
      try {
        const baseUrlHost = `${window.location.protocol}//${window.location.host}`;
        await dispatch(resetPassword({ email, baseUrlHost }));
        if (status !== 'succeeded') {
          setErrorMessage('Please enter correct email format!');
        }
      } catch (err) {
        setErrorMessage('Please enter correct email format!');
      }
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh'
    }}>
      {isEmailValidated && status === 'succeeded' ? (
        <div style={{
          padding: '30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '40%',
          height: '60%',
          border: '1px solid #ddd',
          boxShadow: '0 2px 4px #f4f4f4',
          borderRadius: '5px'
        }}>
          <p style={{ fontSize: '18px', textAlign: 'center', margin: 0, fontWeight: '600' }}>Forgot your password?</p>
          <div className="alert alert-success" style={{ marginTop: '30px' }}>
            Password Reset Requested
          </div>
          <p style={{ fontSize: '16px', fontWeight: '400', textAlign: 'center', marginTop: '20px' }}>
            If the email address you entered matches an existing account, please check your email for instructions on what to do next.
          </p>
          <a href="" style={{ marginTop: '20px', textDecoration: 'none', fontSize: '16px', fontWeight: '400' }} onClick={handleBackToLogin}>
            Back to Login
          </a>
        </div>
      ) : (
        <div style={{
          padding: '30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '40%',
          height: '60%',
          border: '1px solid #ddd',
          boxShadow: '0 2px 4px #f4f4f4',
          borderRadius: '5px'
        }}>
          <p style={{ fontSize: '18px', textAlign: 'center', margin: 0, fontWeight: '600' }}>Forgot your password?</p>
          <p style={{ fontSize: '16px', fontWeight: '400', textAlign: 'center', marginTop: '20px' }}>
            Enter your email address and we will send you a link to reset your password.
          </p>
          <div style={{ width: '100%', maxWidth: '400px', marginTop: '30px' }}>
            <CustomInput
              placeholder="Email Address"
              value={email}
              onChange={handleEmailChange}
            />
          </div>
          {errorMessage && (
            <div className="alert alert-danger" style={{ marginTop: '10px' }}>
              {errorMessage}
            </div>
          )}
          <Button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              backgroundColor: 'rgb(237, 26, 61)',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '5px',
              border: 'none',
              marginTop: '20px'
            }}
          >
            {loading ? 'Submitting...' : 'SUBMIT'}
          </Button>
          <a href="" style={{ marginTop: '20px', textDecoration: 'none', fontSize: '16px', fontWeight: '400' }} onClick={handleBackToLogin}>
            Back to Login
          </a>
        </div>
      )}
    </div>
  );
};

export default ForgotPasswordPage;